<template>
  <page :modifiers="['background-summer-yellow']" class="flex justify-center items-center">
    <div class="bg-white w-156 h-111 flex flex-col justify-center items-start sm:items-center rounded-2xl mx-8 p-8">
      <div class="text-base text-mid-grey font-bold mb-2">
        {{ $t("pages.spaces.nameInputPage.delight") }}
      </div>
      <b-headline typography="h2" type="h2" class="mb-4">
        {{ $t("pages.spaces.nameInputPage.title") }}
      </b-headline>
      <div class="text-base text-dark-grey sm:text-center" v-html="$t('pages.spaces.nameInputPage.description')" />
      <div class="w-72">
        <input-text
          v-model="name"
          name="invitee_name"
          :placeholder="$t('pages.spaces.nameInputPage.nameInputPlaceholder')"
          class="mt-8"
        />
        <div class="text-mid-grey text-sm mb-8">
          {{ $t("pages.spaces.nameInputPage.inputFieldDescription") }}
        </div>
        <b-button class="w-full" :disabled="!isNameInputValid || loading" @click="submit">
          {{ $t("pages.spaces.nameInputPage.join") }}
        </b-button>
      </div>
    </div>
  </page>
</template>

<script>
import Page from "@/shared/page"
import BHeadline from "@/component-library/b-headline"
import InputText from "@/component-library/input-text"
import BButton from "@/component-library/b-button"
import spacesApi from "@/api/spaces"
import { go } from "@/utils/location"

export default {
  name: "NameInputPage",
  components: {
    Page,
    BHeadline,
    InputText,
    BButton
  },
  props: {
    nickname: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      name: this.nickname,
      loading: false
    }
  },
  computed: {
    trimmedNameInput() {
      return this.name.trim()
    },
    isNameInputValid() {
      // This Regex allowlist matches the following (plus hyphens):
      // \p{L} matches any kind of letter from any language
      // \p{Z} matches any kind of whitespace or invisible separator
      // \p{Mn} matches a character intended to be combined with another character without taking up extra space (e.g. accents, umlauts, etc.)
      // \p{Nd} matches a digit zero through nine in any script except ideographic scripts
      // This should be aligned with the mobile apps, where we use the same Regex to check name input.
      // More on Unicode property escapes: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Unicode_Property_Escapes
      // Unicode General Category Property: https://unicode.org/reports/tr18/#General_Category_Property
      const regexAllowList = /^[\p{L}\p{Z}\p{Mn}\p{Nd}-]*$/gu

      return this.trimmedNameInput.length > 1 && regexAllowList.test(this.trimmedNameInput)
    },
    inviteCode() {
      const pathnameParts = window.location.pathname.split("/")
      return pathnameParts[pathnameParts.length - 2]
    }
  },
  methods: {
    submit() {
      this.loading = true

      spacesApi
        .addSpaceMember({
          nickname: this.trimmedNameInput,
          inviteCode: this.inviteCode
        })
        .then((data) => {
          if (data.location) {
            go(data.location)
          }
        })
        .catch((data) => {
          const errorMessage = data?.content?.error || this.$t("pages.spaces.nameInputPage.apiError")

          this.$store?.dispatch("toaster/push", {
            id: "api/addSpaceMember",
            message: errorMessage,
            type: "error"
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
